import { Observable } from 'rxjs';
import { ActionItem, ApiActionBundle, combineLatestAlwaysEmit } from '@stylehaven/components';
import { map } from 'rxjs/operators';
import { AsyncMoreActionsButton } from './more-actions.helper';

export function asyncIconActionItemStreamHelper(
    iconActionStreams: Observable<ActionItem | null>[],
    nonIconActionStreams: Observable<ActionItem | null>[],
    apiActions?: Observable<ApiActionBundle>
): Observable<ActionItem[]> {
    return combineLatestAlwaysEmit(iconActionStreams).pipe(
        map(iconActions => iconActions.filter((action): action is ActionItem => !!action)),
        map(iconActions => iconActions.filter(action => !!action.icon)),
        map(iconActions =>
            iconActions.concat([
                AsyncMoreActionsButton(mergeNonIconActions(iconActions, nonIconActionStreams, apiActions))
            ])
        )
    );
}

function mergeNonIconActions(
    iconActions: ActionItem[],
    nonIconActions: Observable<ActionItem | null>[],
    apiActions?: Observable<ApiActionBundle>
): Observable<ActionItem | null>[] {
    const iconActionLabels: Set<string> = new Set(iconActions.map(action => action.label));
    const resultStreams: Observable<ActionItem | null>[] = [];
    for (const nonIconAction$ of nonIconActions) {
        const hideAction$: Observable<ActionItem | null> = nonIconAction$.pipe(
            map(action => {
                if (action && iconActionLabels.has(action.label)) {
                    action.hidden = true; // Hide actions in the dropdown that already have an icon.
                }
                return action;
            })
        );

        resultStreams.push(hideAction$);
    }

    if (apiActions) {
        resultStreams.push(apiActions);
    }

    return resultStreams;
}
